module.exports = __webpack_public_path__ + "static/media/game-cvinterviewericon7.e750fb84.png";